import React from 'react';

import { Icon } from './styles';

const UpTriangleIcon = () => <Icon className="down-triangle-icon" />;

export default UpTriangleIcon;
